export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/15513584982"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat with us on WhatsApp"
    >
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 0C7.164 0 0 7.164 0 16c0 2.825.738 5.48 2.026 7.778L0 32l8.448-2.016A15.914 15.914 0 0 0 16 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.333c-2.528 0-4.912-.7-6.944-1.92l-.496-.296-5.152 1.232 1.296-5.024-.32-.512A13.246 13.246 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333z"/>
        <path d="M23.136 19.52c-.384-.192-2.272-1.12-2.624-1.248-.352-.128-.608-.192-.864.192-.256.384-1.008 1.248-1.232 1.504-.224.256-.448.288-.832.096-.384-.192-1.616-.592-3.072-1.888-1.136-.992-1.904-2.224-2.128-2.608-.224-.384-.024-.592.168-.784.176-.176.384-.448.576-.672.192-.224.256-.384.384-.64.128-.256.064-.48-.032-.672-.096-.192-.864-2.08-1.184-2.848-.32-.768-.64-.64-.864-.64h-.736c-.256 0-.672.096-.992.48-.32.384-1.248 1.216-1.248 2.976s1.28 3.456 1.456 3.68c.176.224 2.528 3.84 6.112 5.376.864.368 1.536.592 2.064.752.864.272 1.648.232 2.272.144.688-.104 2.272-.928 2.592-1.824.32-.896.32-1.664.224-1.824-.096-.16-.352-.256-.736-.448z"/>
      </svg>
    </a>
  )
}
